/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 ListItemIcon — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations: color via NS fg-subtle token (i.p.v. palette.action.active dat
// MUI default is — beide zijn "secondary affordance" tinten; NS-token is mode-aware en
// matcht Tractie's icon-tint conventie voor nav/list contexts).
// minWidth 56 (MUI default — geeft alignment met ListItemText.inset paddingLeft 56).

export const MuiListItemIconLightOverrides = {
  root: {
    minWidth: 56,
    color: 'var(--ns-color-fg-subtle)',
    flexShrink: 0,
    display: 'inline-flex' as const,
  },

  alignItemsFlexStart: {
    marginTop: 8,
  },
} as const;

// Dark variant — token --ns-color-fg-subtle is mode-aware via tokens.css.
export const MuiListItemIconDarkOverrides = {
  ...MuiListItemIconLightOverrides,
} as const;
